module.exports = __webpack_public_path__ + "img/Meine_Praemienbestellungen_1536x360.17db9ce8.png";